var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"padding-top":"15px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"48"}})],1):_c('NewCurve',{attrs:{"dataCurve":null}})}
var staticRenderFns = []

export { render, staticRenderFns }